import { i18n } from '@lt/localization';
import React, { useEffect, useState } from 'react';

import RadioFilterGroup from '../../../../../../../components/Filters/components/RadioFilterGroup';
import type {
  ExtendedFilterInfo,
  CommonFilterProps,
  FilterData,
} from '../types';

const FilterLuggageType = (props: CommonFilterProps): JSX.Element => {
  const { onClear, onChangeSingleOption, data } = props;
  const handleChange = (diff) => {
    onChangeSingleOption({ path: 'luggage_types', diff });
  };

  const [filters, setFilters] = useState<FilterData>([]);

  useEffect(() => {
    setFilters(data);
  }, [data]);

  useEffect(() => {
    /**
     * По умолчанию опция 'all' должна быть выбрана,
     * но с бека в ручке flights все опции приходят невыбранными
     */
    if (data.every((filter) => !filter.selected))
      setFilters([{ ...data[1], selected: true }, data[0], data[2]]);
    else setFilters([data[1], data[0], data[2]]);
  }, [data]);

  const handleClear = () => onClear('luggage_types');

  return (
    <RadioFilterGroup
      {...props}
      data={filters}
      Filter={FilterLuggageType}
      onChange={handleChange}
      onClear={handleClear}
    />
  );
};

const filterNames = {
  all: i18n.t('checkout.filter.luggage.all'),
  heavy: i18n.t('checkout.filter.luggage.heavy'),
  hold: i18n.t('checkout.filter.luggage.hold'),
};

FilterLuggageType.getFilterVisibleName = (
  filterOptionData: ExtendedFilterInfo,
) => filterOptionData.id && filterNames[filterOptionData.id];

FilterLuggageType.filterName = 'luggage_types';
FilterLuggageType.filterLabel = i18n.t('checkout.filter.luggage.hold');

export default FilterLuggageType;
